import { Hotel, PocketRD } from 'tokyu-hooks'
import { toAvailabilityCalendarModel } from 'core/bookings'
import { GetAvailabilityCalendarResponse } from 'tokyu-hooks/lib/response/hotel'

export const FETCH_AVAILABILITY_CALENDAR = 'FETCH_AVAILABILITY_CALENDAR'

export const fetchAvailabilityCalendar =
  (clientSession: string, _?: string | null) =>
  async ({ queryKey }: { queryKey: any[] }) => {
    const [_key, { year_month, nights, hotelId, rooms, locale, showResale }] =
      queryKey

    const res = await Hotel.getAvailabilityCalendar({
      baseUrl: process.env.NEXT_PUBLIC_TRIPLA_BASE_URL as string,
      clientSession: clientSession,
      year_month: year_month as string,
      nights: nights,
      hotel_id: hotelId as string,
      rooms: rooms as {
        adults: number
        children: number
      }[],
      locale: locale as string,
    })

    let pocketRdAvailabilityCalendar:
      | GetAvailabilityCalendarResponse['data']
      | undefined = undefined

    if (!!showResale) {
      try {
        const pocketRdRes = await PocketRD.getAvailabilityCalendar({
          baseUrl: process.env.NEXT_PUBLIC_POCKETRD_BASE_URL as string,
          apiKey: process.env.NEXT_PUBLIC_POCKETRD_API_KEY as string,
          year_month: year_month as string,
          hotel_id: hotelId as string,
          adults: rooms?.adults ? Number(rooms?.adults) : undefined,
          children: rooms?.children ? Number(rooms?.children) : undefined,
        })

        pocketRdAvailabilityCalendar = { ...pocketRdRes?.data, id: 0 }
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          console.warn(
            '[PocketRD] Availability calendar failed, skipping:',
            error,
          )
        } else {
          throw error
        }
      }
    }

    const triplaAvailabilityCalendar = res?.data?.data
    return res?.data?.data
      ? toAvailabilityCalendarModel(
          triplaAvailabilityCalendar,
          pocketRdAvailabilityCalendar,
        )
      : undefined
  }
